import React from 'react';
import {Link} from 'react-router-dom';
import Button from '@mui/material/Button';

interface BottomButtonsProps {
	button1?: string,
	onClick1?(): void,
	link1?:string,
	href1?:string,
	icon1?: any,
	disabled1?: boolean,
	button2?: string,
	onClick2?(): void,
	link2?:string,
	href2?:string,
	icon2?: any,
	disabled2?: boolean,
	button3?: any,
	onClick3?(): void,
	link3?:string,
	href3?:string,
	icon3?: any,
	disabled3?: boolean,
	actions?:boolean,
	bottom?:number,
	top?:number,
}

const BottomButtons:React.FC<BottomButtonsProps> = (props)=> {
	const click1 = ()=>{
		if( props.onClick1 ){
			props.onClick1();
		}
	}
	const click2 = ()=>{
		if( props.onClick2 ){
			props.onClick2();
		}
	}
	const click3 = ()=>{
		if( props.onClick3 ){
			props.onClick3();
		}
	}
	let bottom = 1;
	if( props.bottom!==null && props.bottom!==undefined ){
		bottom = props.bottom;
	}
	let top = 2;
	if( props.top!==null && props.top!==undefined ){
		top = props.top;
	}

	let disabled1 = false;
	let disabled2 = false;
	let disabled3 = false;
	if( props.disabled1!==null && props.disabled1===true ){
		disabled1 = true;
	}
	if( props.disabled2!==null && props.disabled2===true ){
		disabled2 = true;
	}
	if( props.disabled3!==null && props.disabled3===true ){
		disabled3 = true;
	}

	return (
		<div style={{marginTop:`${top}em`,marginBottom:`${bottom}em`,textAlign:'right',position:'relative'}}>
			{props.button3 && props.onClick3 &&
			<Button variant="outlined" color="primary" onClick={click3} style={{position:'absolute',left:0}} startIcon={props.icon3} disabled={disabled3}>{props.button3}</Button>
			}
			{props.button3 && props.link3 &&
			<Link to={props.link3}><Button variant="outlined" color="primary" style={{position:'absolute',left:0}} startIcon={props.icon3} disabled={disabled3}>{props.button3}</Button></Link>
			}
			{props.button3 && props.href3 &&
			<a href={props.href3} rel="noopener noreferrer" target="_blank"><Button variant="outlined" color="primary" style={{position:'absolute',left:0}} startIcon={props.icon3} disabled={disabled3}>{props.button3}</Button></a>
			}
			{props.button2 && props.onClick2 &&
			<Button variant="text" color="primary" onClick={click2} style={{marginRight:'0.25em'}} startIcon={props.icon2} disabled={disabled2}>{props.button2}</Button>
			}
			{props.button2 && props.link2 &&
			<Link to={props.link2}><Button variant="text" color="primary" style={{marginRight:'0.25em'}} startIcon={props.icon2} disabled={disabled2}>{props.button2}</Button></Link>
			}
			{props.button2 && props.href2 &&
			<a href={props.href2} rel="noopener noreferrer" target="_blank"><Button variant="text" color="primary" style={{marginRight:'0.25em'}} startIcon={props.icon2} disabled={disabled2}>{props.button2}</Button></a>
			}
			{props.button1 && props.onClick1 &&
			<Button variant="contained" color="primary" onClick={click1} startIcon={props.icon1} disabled={disabled1}>{props.button1}</Button>
			}
			{props.button1 && props.link1 &&
			<Link to={props.link1}><Button variant="contained" color="primary" startIcon={props.icon1} disabled={disabled1}>{props.button1}</Button></Link>
			}
			{props.button1 && props.href1 &&
			<a href={props.href1} rel="noopener noreferrer" target="_blank"><Button variant="contained" color="primary" startIcon={props.icon1} disabled={disabled1}>{props.button1}</Button></a>
			}
		</div>
	)
}

export default BottomButtons;
